import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React, { useEffect } from 'react';
import withTechContemporaryUniverseGuard from 'src/HOCs/withTechContemporaryUniverseGuard';
import PageMeta from 'src/components/organisms/page-meta';
import { PAGES_LOCALES } from 'src/constants/common.constants';
import { StyledAppContainer } from 'src/features/white-labels/techcontemporary/app/components/app-container/app-container.styles';
import { CalendarContainer } from 'src/features/white-labels/techcontemporary/calendar';
import { fetchEventsThunk } from 'src/features/white-labels/techcontemporary/calendar/ducks/calendar.thunk';
import { useAppDispatch } from 'src/hooks/app';
import { wrapper } from 'src/store';

const Calendar = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchEventsThunk());
    }, [dispatch]);

    return (
        <>
            <PageMeta title="Calendar" />
            <StyledAppContainer>
                <CalendarContainer />
            </StyledAppContainer>
        </>
    );
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps((store) => async (ctx) => {
    // @ts-ignore
    await store.dispatch(fetchEventsThunk());

    const props = {
        ...(await serverSideTranslations(ctx.locale as string, PAGES_LOCALES)),
    };

    return { props };
});
export default withTechContemporaryUniverseGuard(Calendar);